import type { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
});

export const meta: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '0.5rem 0.75rem',
    color: theme.colors.textSecondary,
    fontSize: '0.8125rem',
});

export const truncated: TRuleWithTheme = ({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.colors.statusPending,
    fontWeight: 600,
});

export const table: TRuleWithTheme = ({ theme }) => ({
    '& .ant-table': {
        border: `1px solid ${theme.colors.borderColor}`,
        borderRadius: '0.5rem',
    },
    '& .ant-table-thead > tr > th': {
        backgroundColor: theme.colors.bgPrimary,
        fontWeight: 600,
    },
});

export const sqlDisclosure: TRuleWithTheme = () => ({
    '&.ant-collapse': {
        backgroundColor: 'transparent',
        border: 'none',
    },
    '& .ant-collapse-item': {
        border: 'none',
    },
    '& .ant-collapse-header': {
        padding: '0 !important',
        fontSize: '0.8125rem',
    },
    '& .ant-collapse-content-box': {
        padding: '0.5rem 0 0 !important',
    },
});

export const sqlBlock: TRuleWithTheme = ({ theme }) => ({
    margin: 0,
    padding: '0.875rem 1rem',
    borderRadius: '0.5rem',
    backgroundColor: theme.colors.text,
    color: theme.colors.white,
    fontFamily: 'Menlo, Consolas, monospace',
    fontSize: '0.8125rem',
    lineHeight: 1.6,
    overflowX: 'auto',
    whiteSpace: 'pre',
});
